import controlTemplate from './starting-view-menu-toggle.hbs'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import DatasetTreeItemSelector from 'scoreboard/datasets/records/dataset-tree-item-selector'
import loadingDots from 'scoreboard/components/loading-dots.hbs'
import _ from 'lodash'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import DatasetTreeGardener from 'scoreboard/datasets/dataset-tree-gardener'

const LocationsTreeGardener = DatasetTreeGardener.extend({
	_url: function(opt) {
		return 'api/locations/trees/' + opt.id
	},

	forest: true
})

const StartingViewMenu = DatasetTreeItemSelector.extend({

	tagName: 'form',

	Gardener: LocationsTreeGardener,

	title: () => i18n.get('common.set2',
		i18n.get('charts.chart.settingType.startingView')),

	primaryButtonText: () => i18n.get('common.done'),

	initialize: function(options) {
		this.options = options || {}
		this.autoStartingView = _.isNil(this.options.selectedId)
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		DatasetTreeItemSelector.prototype.render.apply(this, arguments)
		this.$('.panel')
			.append(loadingDots())
			.before(controlTemplate())

		this.gardener.once('tree:rendered', () => {
			this.$('.loading-dots').remove()
		})

		this.autoStartingView &&
			this.$('.panel').addClass('is-not-displayed')
		this.renderStartingViewTypeToggle()
	},

	renderStartingViewTypeToggle: function() {
		const value = this.autoStartingView ? 'auto' : 'specific-region'
		this.startingViewTypeToggle = new LabeledToggle({
			value,
			options: [{
				value: 'auto',
				label: 'common.auto'
			},
			{
				value: 'specific-region',
				label: 'charts.chart.settingType.startingView.specificRegion'
			}]
		})
		this.$('.toggle-container').append(this.startingViewTypeToggle.el)
		this.startingViewTypeToggle.render()

		this.startingViewTypeToggle.on('change', () => {
			this.$('.panel').toggleClass('is-not-displayed',
				this.isAutoStartingView())
			this.formView.change()
		})
	},

	isAutoStartingView: function() {
		return this.startingViewTypeToggle.val() === 'auto'
	},

	submit: function() {
		const autoStartingView = this.isAutoStartingView()
		const selected = this.gardener.tree.selected()
		const data = {
			// only update tree id and key if it is currently displayed
			startingViewTreeId: autoStartingView ? null : selected.id,
			autoStartingView
		}
		this.trigger('done', data)
	}
})

export default StartingViewMenu
StartingViewMenu.__filename__ = 'charts/edit/starting-view-menu.js'
